var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"sticky-footer bg-white"},[_c('div',{staticClass:"container my-auto"},[_c('div',{staticClass:"copyright text-center my-auto"},[_c('span',[_vm._v(" Copyright © HMIP | NMRC "+_vm._s(new Date().getFullYear())+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }